import React, {useState, useEffect} from 'react';
import '../../style/infoTable.scss'
import { useTranslation } from "react-i18next";
import { useSelector } from 'react-redux';
import { BASE_URL } from '../../http/BaseUrl';
import axios from 'axios';
const InfoTable = () => {
    const [paper, setPaper] = useState();
    const [film, setFilm] = useState();
    const [laminationPrices, setLaminationPrices] = useState();
    const { t } = useTranslation();
    const { currency } = useSelector((state) => state.currency);

    useEffect(() => {
        axios.get(`${BASE_URL}/get-info-table`)
        .then((res) => {
            setPaper(res?.data?.goods[0]);
            setFilm(res?.data?.goods[1]);
            setLaminationPrices(res?.data?.goods[0]?.lamination[1]?.prices)
        })
        .catch((error) => console.log('error',error))
    },[])

    return (
        <div className='infoTable_container infoTable__border'>
            <div className='infoTable_table infoTable__border'>
                <div className='infoTable__column_title infoTable__columnBorder'>
                    <p className='infoTable__borderBottom' style={{minHeight: '15px'}}>{''}</p>
                    <p className='infoTable__borderBottom'>{t('Папір самоклеючий')}</p>
                    <p className='infoTable__borderBottom'>{t('Папір з ламінацією м/г')}</p>
                    <p>{t('Плівка з ламінацією м/г')}</p>
                </div>
                <div className='infoTable__column infoTable__columnBorder'>
                    <p className='infoTable__borderBottom '>{t('1-25 ар. А3')}</p>
                    <p className='infoTable__borderBottom'>{(currency.currency * paper?.prices?.small).toFixed(2)} грн./ар.</p>
                    <p className='infoTable__borderBottom'>{(currency.currency * (paper?.prices?.small + laminationPrices?.small)).toFixed(2)} грн./ар.</p>
                    <p>{(currency.currency * film?.prices?.small).toFixed(2)} грн./ар.</p>
                </div>
                <div className='infoTable__column infoTable__columnBorder'>
                    <p className='infoTable__borderBottom'>{t('25-50 ар. А3')}</p>
                    <p className='infoTable__borderBottom'>{(currency.currency * paper?.prices?.average).toFixed(2)} грн./ар.</p>
                    <p className='infoTable__borderBottom'>{(currency.currency * (paper?.prices?.average + laminationPrices?.average)).toFixed(2)} грн./ар.</p>
                    <p>{(currency.currency * film?.prices?.average).toFixed(2)} грн./ар.</p>
                </div>
                <div className='infoTable__column'>
                    <p className='infoTable__borderBottom'>{t('50+ ар. А3')}</p>
                    <p className='infoTable__borderBottom'>{(currency.currency * paper?.prices?.many).toFixed(2)} грн./ар.</p>
                    <p className='infoTable__borderBottom'>{(currency.currency * (paper?.prices?.many + laminationPrices?.many)).toFixed(2)} грн./ар.</p>
                    <p>{(currency.currency * film?.prices?.many).toFixed(2)} грн./ар.</p>
                </div>
            </div>
            <div className='infoTable_text'>
                <p>{t('Ціна включає плоттерну або гільйотинну порізку.')}</p>
                <p>{t('Самоклеюча плівка може бути білою або прозорою.')}</p>
                <p>{t('Термін виготовлення 1-3 дні. Залежить від тиражу, щільності заливки та складності порізки.')}</p>
                <p>{t('Надсилаємо Новою поштою по всіх містах України.')}</p>
                <p>{t('Замовлення приймаються у розмірі А3, у векторному форматі, з наложеною порізкою в програмі Corel.')}</p>
            </div>
        </div>
    );
};

export default InfoTable;